<template>
  <div class="sorting-dropdown">
    <button
        v-for="option in sortingOptions"
        :key="option.key"
        @click="selectSorting(option)"
        class="dropdown-item d-flex align-items-center"
        :class="{ active: isSelected(option) }"
    >
      {{ option.label }}
    </button>
    <button
        class="dropdown-item text-muted"
        @click="resetSorting"
    >
      Сбросить сортировку
    </button>
  </div>
</template>

<script>
import {filterStore} from "@/store/filterStore";

export default {
  name: "ListSortingDropdown",
  data() {
    return {
      sortingOptions: [
        {key: "createdAt-desc", field: "createdAt", order: "DESC", label: "Сначала новые"},
        {key: "createdAt-asc", field: "createdAt", order: "ASC", label: "Сначала старые"},
      ],
      filter: filterStore
    };
  },
  methods: {
    selectSorting(option) {
      this.filter.sorting = option.field;
      this.filter.order = option.order;
      this.$emit("select", option);
      this.$emit("close");
    },
    isSelected(option) {
      return (
          this.filter.sorting === option.field &&
          this.filter.order === option.order
      );
    },
    resetSorting() {
      this.filter.sorting = null;
      this.filter.order = null;
      this.$emit("select", null);
      this.$emit("close");
    }
  },
};
</script>

<style scoped>
.sorting-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 200px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
@media (max-width: 520px) {
  .sorting-dropdown {
    left: -100px;
  }
}
.dropdown-item {
  border-bottom: 1px solid #e9ecef;
  padding: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-item.active {
  background-color: #21e58a;
  color: white;
}
</style>